import TitleDescription from './TitleDescription';

export default TitleDescription;
